export default "__VITE_ASSET__98cb14b8__"